import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import ActivityGroupItem from '../../../ActivityGroupItem';

const Item = styled.div`
  background-color: ${props => props.theme.secondaryBackground};
  overflow-y: scroll;
  flex: 1;
  padding: 40px;
`;

const ActivityList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const AcitivityListItem = styled.div`
  display: flex;
  width: 50%;
  margin-bottom: 25px;
`;

const ActivityType = styled.div`
  display: flex;
  margin-right: 20px;
`;

const ActivityItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  margin-top: -8px;
`;

const ActivityItem = styled.div`
  font-size: 16px;
  line-height: 30px;
`;

const ActivitiesTabItem = ({ coachGroups }) => (
  <Item>
    <ActivityList>
      {coachGroups.map(({ group: { id, name, colorCode }, activities }) => (
        <AcitivityListItem key={id}>
          <ActivityType>
            <ActivityGroupItem item={{ name, colorCode }} />
          </ActivityType>
          <ActivityItems>
            {activities.map(activity => <ActivityItem key={activity.id}>{activity.name}</ActivityItem>)}
          </ActivityItems>
        </AcitivityListItem>
      ))}
    </ActivityList>
  </Item>
);

ActivitiesTabItem.propTypes = {
  coachGroups: PropTypes.arrayOf(
    PropTypes.shape({
      group: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        colorCode: PropTypes.string.isRequired
      }).isRequired,
      activities: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired
        }).isRequired
      )
    })
  ).isRequired
};

export default ActivitiesTabItem;



// WEBPACK FOOTER //
// ./src/components/CoachPanel/Tab/ActivitiesTabItem/ActivitiesTabItem.jsx